export enum FormAttribute {
  ADD_SERVICE_MOBILE = 'add-mobile-service',
  ADD_SERVICE_FIXED = 'add-fixed-service',
  ADD_SERVICE_USER_DATA = 'add-service-user-data',
  ADD_SERVICE_CHECK_PASSWORD = 'add-service-check-password',
  CHANGE_EMAIL = 'change-email',
  CHANGE_PASSWORD = 'change-password',
  FORGOT_PASSWORD = 'forgot-password',
  LOGIN = 'login',
  TRUSTED_LOGIN = 'trusted-login',
  NEW_PASSWORD = 'new-password',
  TV_TO_GO_CHECK_PASSWORD='tv-to-go-check-password',
  TV_TO_GO_ADD_NEW_USER='tv-to-go-add-new-user',
  REGISTRATION_ACCOUNT_EXISTS='registration-account-exists',
  REGISTRATION_CHOOSE_TYPE_MOBILE='registration-choose-type-mobile',
  REGISTRATION_CHOOSE_TYPE_FIXED='registration-choose-type-fixed',
  REGISTRATION_CREATE_ACCOUNT='registration-create-account',
  SUPPORT='support',
  TOPUP_CREDIT='topup-credit',
  TOPUP_DEBIT='topup-debit',
}
